import script from "./HeaderDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./HeaderDetailsPage.vue?vue&type=style&index=0&id=698fe99e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-698fe99e"]])

export default __exports__